import React, { useState } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { delay, isEmpty, noop } from 'lodash';
import fetchReviewAsync from '../../../../../utils/fetchReviewAsync';
import { fetchUGC, updateGalleryReviewsUGC } from '../../../../../actions/ugc';
import { isTranslated } from '../../../../../utils/ugc/isTranslated';
import { buildSourceInfo } from '../../../../../utils/ugc/buildSourceInfo';

const GALLERY_REVIEW_SOURCE = 'gallery_review';

const SlideHOCWrapper = (WrappedComponent) => {

    const SlideHOC = (props, context) => {
        const {
            slide,
            updateGalleryReviewsUGC,
            showTranslatedUGC,
            fetchUGC
        } = props;
        const { pathfinderWrapper, general } = context;
        const { gigId } = general;

        const [review, setReview] = useState(null);
        const [isShowingReview, setIsShowingReview] = useState(false);
        const [timerId, setTimerId] = useState(null);

        const showReview = async(hide = false) => {
            const { isWorkSample } = slide;
            if (!isWorkSample) { return; }

            const review = await getReview();
            if (isEmpty(review)) { return; }

            clearTimeout(timerId);
            if (hide) {
                setTimerId(delay(hideReview, 4000));
            }
            setIsShowingReview(true);
        };

        const getReview = async() => {
            const { orderId } = slide;
            let orderReview = review;

            if (!orderReview) {
                orderReview = await fetchReviewAsync({ orderId, pathfinderWrapper });
                updateGalleryReviewsUGC(orderReview);
                if (showTranslatedUGC) {
                    const sourceInfo = buildSourceInfo(({ componentName: GALLERY_REVIEW_SOURCE, gigId }));
                    await fetchUGC({ sourceInfo, shouldToggle: false });
                }
                setReview(orderReview);
            }

            return orderReview;
        };

        const hideReview = () => {
            clearTimeout(timerId);
            setIsShowingReview(false);
        };

        const flashReview = () => {
            hideReview();
            setTimerId(delay(showReview, 200, true));
        };

        const toggleReview = async() => {
            if (isShowingReview) {
                hideReview();
            } else {
                await showReview();
            }
        };

        return (
            <WrappedComponent {...props}
                flashReview={flashReview}
                toggleReview={toggleReview}
                hideReview={hideReview}
                review={review}
                isShowingReview={isShowingReview}/>
        );
    };

    SlideHOC.propTypes = {
        slide: object,
        updateGalleryReviewsUGC: func
    };

    SlideHOC.defaultProps = {
        slide: {},
        updateGalleryReviewsUGC: noop
    };

    SlideHOC.contextTypes = {
        pathfinderWrapper: object,
        general: object
    };

    const mapStateToProps = ({ ugc }) => {
        const showTranslatedUGC = isTranslated(ugc);

        return {
            showTranslatedUGC
        };
    };

    return connect(mapStateToProps, {
        updateGalleryReviewsUGC,
        fetchUGC
    })(SlideHOC);
};

export default SlideHOCWrapper;
